import { SaleRow } from "@/models/base";
import { SaleEditState } from "./sale-edit-state";
import { AuthService, ProductService } from "@/services";
import { MODULE } from "@/config/modules";


export class SaleEditSelectProductTrackingNumbersData {
	private saleEditState:SaleEditState;
	public selectedTrackingNumbers:{number:string, qty:number}[] = [];
	public row:SaleRow | null = null;
	private onSuccessHandler:((rows:SaleRow[])=>void) | null = null;
	private onFailHandler:Function | null = null;

	public constructor(state:SaleEditState){
		this.saleEditState = state;
	}

	// eslint-disable-next-line max-lines-per-function
	public async selectAutomaticTrackingNumbersForRow(row:SaleRow):Promise<SaleRow[]> {
		if (!AuthService.hasModule(MODULE.WERKEN_MET_TRACERING)) return [row];
		if (row.ProductSku == "" || (this.saleEditState.config && !this.saleEditState.config.UseProductTrackingNumbers)) {
			row.TrackingNumber = "";
			return [row];
		}
		if (row.TrackingNumber != ""){
			return [row];
		}
		this.selectedTrackingNumbers = [];
		let product = row.Product;
		if (!product){
			product = await ProductService.getProductBySku(row.ProductSku);
			if (!product){
				return [row];
			}
		}
		let stockState = await ProductService.getTrackingNumbersByDate(product.ID, 100, 0);
		let toBook = row.Amount;
		let result:SaleRow[] = [];
		for (let stock of stockState) {
			let qty = Math.min(toBook, stock.getTotalInStock());
			if (qty == 0) break;
			let newRow = new SaleRow(row.getJSON());
			if (qty != row.Amount) {
				newRow.ID = 0;
			}
			newRow.Product = product;
			newRow.Amount1 = qty;
			newRow.TrackingNumber = stock.TrackingNumber;
			newRow.TrackingNumberData = stock;
			result.push(newRow);
			toBook -= qty;
			if (toBook <= 0){
				break;
			}
		}
		if (result.length == 0) {
			return [row];
		}
		return result;
	}

	public confirm(){
		if (!this.onSuccessHandler) return;
		let result:SaleRow[] = this.selectedTrackingNumbers.map(n=>{
			if (!this.row) return null;
			let newRow = new SaleRow(this.row.getJSON());
			if (this.selectedTrackingNumbers.length > 1){
				newRow.ID = 0;
			}
			newRow.Product = this.row.Product;
			newRow.TrackingNumber = n.number;
			newRow.Amount1 = n.qty;
			return newRow;
		}).filter(r=>r != null) as any[] as SaleRow[];
		this.row = null;
		this.onSuccessHandler(result);
	}

	public cancel(){
		if (!this.onFailHandler) return;
		this.row = null;
		this.onFailHandler();
	}


	public skip(){
		if (!this.onSuccessHandler) return;
		if (!this.row) return;
		let row = this.row;
		this.row = null;
		this.onSuccessHandler([row]);
	}
}